module.exports = __webpack_public_path__ + "img/home-case-02.dae58ea4.png";